import { QuestionCircleOutlined } from "@ant-design/icons";
import { Form, Tooltip } from "antd";
import { RequiredBadge } from "./RequiredBadge";

interface PublicStatusProps {
	primaryColor?: string;
}

export const PublicStatus = ({
	primaryColor = "#99CA29",
}: PublicStatusProps) => {
	return (
		<Form.Item
			name="isDisplayed"
			label={
				<div className="flex items-center">
					<span className="font-bold">公開状態</span>
					<Tooltip
						overlayInnerStyle={{ width: 570 }}
						title={
							<div>
								<div>イベント一覧の表示・非表示制御です。</div>
								<div>■表示</div>
								<div>
									イベント予約可能期間に関わらず、イベント一覧に表示されます。
								</div>
								<div>■非表示</div>
								<div>イベント一覧から非表示になります。</div>
								<div>
									イベントURLをコピーして、イベントを知ってほしいユーザーにLINE配信してください。
								</div>
							</div>
						}
					>
						<QuestionCircleOutlined
							className="ml-2"
							style={{ color: primaryColor }}
						/>
					</Tooltip>
					<RequiredBadge />
				</div>
			}
			rules={[
				{
					required: true,
					message: "表示状態を選択してください",
				},
			]}
			valuePropName="value"
			getValueProps={(value) => {
				if (typeof value === "string" && ["true", "false"].includes(value)) {
					return { value: value === "true" };
				}
				return { value };
			}}
		>
			<Form.Item noStyle shouldUpdate>
				{({ getFieldValue, setFieldValue }) => {
					const isDisplayed = getFieldValue("isDisplayed");
					return (
						<div className="flex">
							<button
								type="button"
								onClick={() => setFieldValue("isDisplayed", true)}
								className={`py-1.5 px-6 border border-gray-300 rounded-l-md cursor-pointer ${
									isDisplayed === true
										? "text-white font-medium border-r-0"
										: "bg-white text-black font-normal border-r-0"
								}`}
								style={{
									backgroundColor: isDisplayed === true ? primaryColor : "#fff",
								}}
							>
								表示
							</button>
							<button
								type="button"
								onClick={() => setFieldValue("isDisplayed", false)}
								className={`py-1.5 px-6 border border-gray-300 rounded-r-md cursor-pointer ${
									isDisplayed === false
										? "text-white font-medium"
										: "bg-white text-black font-normal"
								}`}
								style={{
									backgroundColor:
										isDisplayed === false ? primaryColor : "#fff",
								}}
							>
								非表示
							</button>
						</div>
					);
				}}
			</Form.Item>
		</Form.Item>
	);
};
